import axios, { InternalAxiosRequestConfig } from 'axios'
import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { RefreshActions } from '../state/refresh'

export const AxiosConfigContainer = (): JSX.Element => {
  const dispatch = useDispatch()

  const showSpinner = (): void => {
    dispatch(RefreshActions.showSpinner())
  }

  const hideSpinner = (): void => {
    dispatch(RefreshActions.hideSpinner())
  }

  const setUpInterceptors = useCallback(async () => {
    axios.interceptors.request.use(
      function (config: InternalAxiosRequestConfig) {
        if ((config as any).showLoader !== false) {
          showSpinner()
        }
        return config
      },
      async function (error) {
        return await Promise.reject(error)
      }
    )

    axios.interceptors.response.use(
      function (response) {
        hideSpinner()
        return response
      },
      async function (error) {
        hideSpinner()
        return await Promise.reject(error)
      }
    )
  }, [])

  useEffect(() => {
    void setUpInterceptors()
  }, [setUpInterceptors])

  return <></>
}
